/**
 * @module webdnn
 */
/**
 * PlaceholderContext manages the placeholders
 * @protected
 */
export default class PlaceholderContext {
    constructor(values) {
        this.values = {};
        if (values) {
            this.update(values);
        }
    }
    get isResolved() {
        return Object.values(this.values).every(value => typeof value == 'number');
    }
    update(values) {
        this.values = Object.assign(this.values, values);
    }
    resolve(placeholder) {
        // Literal value => return itself.
        if (typeof placeholder !== 'object')
            return placeholder;
        // Placeholder object ( { eval: string } ) => resolve
        if (Object.keys(placeholder).length == 1 && 'eval' in placeholder) {
            if (!this.isResolved)
                throw Error(`Not all placeholders are resolved: ${this}`);
            return eval('(function(placeholders){return ' + placeholder.eval + ';})')(this.values);
        }
        // Array => deep copy
        if (placeholder instanceof Array) {
            return placeholder.map((value) => this.resolve(value));
        }
        // Object => deep copy
        return Object.entries(placeholder)
            .reduce((result, [key, value]) => {
            result[key] = this.resolve(value);
            return result;
        }, {});
    }
    toString() {
        return JSON.stringify(this.values);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/descriptor_runner/placeholder.js
// module id = 5
// module chunks = 0